<template>
  <div>
    <h3 class="title dw_green--text font-weight-light">
      <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiShieldHalfFull" />
      CWE&trade; Weaknesses
    </h3>
    <v-row no-gutters>
      <v-col cols="11">
        <v-text-field
          v-model="search"
          @change="searchExisting"
          @click:clear="search = ''; searchExisting()"
          label="Search Weaknesses"
          :append-icon="mdiMagnify"
          color="dw_green"
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card width="33vw" max-height="50vh" class="pa-2 my-2 existing-list">
      <p v-for="cwe of cwes" :key="cwe" class="grey--text caption mb-1">{{ cwe }}</p>
    </v-card>
  </div>
</template>

<script>
import { mdiShieldHalfFull, mdiMagnify } from '@mdi/js';
import { mapGetters } from 'vuex';

export default {
  name: 'cweList',
  data() {
    return {
      mdiShieldHalfFull,
      mdiMagnify,
      search: '',
      cwes: []
    }
  },
  computed: {
    ...mapGetters([
      'cweOptions'
    ])
  },
  mounted() {
    this.cwes = this.cweOptions.map((cwe) => `CWE-${cwe.id} ${cwe.name}`);
  },
  methods: {
    searchExisting() {
      this.cwes = this.cweOptions.map((cwe) => cwe.name);
      if (this.search !== '') {
        this.cwes = this.cwes.filter((cwe) => {
          const s = this.search.toLowerCase();
          return cwe.toLowerCase().includes(s);
        });
      }
    }
  }
};
</script>

<style scoped>
.existing-list {
  height: inherit;
  overflow-y: scroll;
}
</style>
